export const CONSENT_TYPES = {
    TERMS_OF_SERVICE: 'TERMS_OF_SERVICE',
    MARKETING_POLICY: 'MARKETING_POLICY',
    HANDLE_PERSONAL_DATA: 'HANDLE_PERSONAL_DATA',
    SHARE_DATA_OUTSIDE_EU: 'SHARE_DATA_OUTSIDE_EU',
    IMPROVE_ALVA: 'IMPROVE_ALVA'
};
